export class GoogleWorkspaceRestoreAccountAttributes {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "gcpProjectId",
            "baseName": "gcpProjectId",
            "type": "string",
            "format": ""
        },
        {
            "name": "serviceAccount",
            "baseName": "serviceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "restoreServiceAccount",
            "baseName": "restoreServiceAccount",
            "type": "string",
            "format": ""
        },
        {
            "name": "delegatedAdminEmail",
            "baseName": "delegatedAdminEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "primaryDomain",
            "baseName": "primaryDomain",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GoogleWorkspaceRestoreAccountAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
